import { configureStore, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getImage } from "./Component/utils/datautils";

const resource = createSlice({
    name:'res',
    initialState: {
        page:'home',
        admin:{name:''},
        dataAdmin:[],
        residueImg:[],
        data:{
            'department':['tu','iwoa'],
            'visi':['askdgsad'],
            'misi':[],
            'staff':[{
                'image':null,
                'name':'asdasd',
                'tahun':new Date().getFullYear(),
                'departemen':'asdas',
                'jabatan':'asdasd',
                'motivasi':'askdhais dshi hsdih uihsd',
                'facebook':'alksdjkas',
                'instagram':'kashdkas'
              }],
            'alumni':[{
                'image':null,
                'name':'asdasd',
                'tahun':2020,
                'departemen':'asdas',
                'jabatan':'asdasd',
                'motivasi':'askdhais dshi hsdih uihsd',
                'facebook':'alksdjkas',
                'instagram':'kashdkas'
              }],
            'activity':[{
                'images':[],
                'title':'ashdkahs',
                'descTitle':'dfjklsdjfjsdf',
                'descMain':'@pkasndkkaknasnkdkk@pakjsbdjkabjsdjbasjbd@l@llasdasdasj ascasdas sdasdasd sdaasdasll@@llnkajs nsdjk njsdn sdj bhsdb bhjsbd bhjshjdb hjbsdb hjbsd bhjsb jhsdb bhjsdb hjbsdj bhjsdb hjbjhjbhjb hjsbhj sa hjsahjsa hjshj s sd hjndjknjjasnjdnll@l@',
                'rilis':'2023-09-12'
              }],
            'achievement':[{
                'images':[],
                'title':'jfivjifdnc',
                'descMain':'@pkasndkkaknasnkdkk@pakjsbdjkabjsdjbasjbd@l@llasdasdasj ascasdas sdasdasd sdaasdasll@@llnkajs nsdjk njsdn sdj bhsdb bhjsbd bhjshjdb hjbsdb hjbsd bhjsb jhsdb bhjsdb hjbsdj bhjsdb hjbjhjbhjb hjsbhj sa hjsahjsa hjshj s sd hjndjknjjasnjdnll@l@',
                'tanggal':'2023-02-04'
            }],
            "socialmedia":[
                {"email":"mpq.umsurakarta@gmail.com"},
                {"facebook":"https://www.facebook.com/mpa.ums.73"},
                {"instagram":"https://instagram.com/mpq_ums"},
                {"youtube":"https://youtube.com/channel/UCpTANYD8RiFWrdAvGVaHDFw"}
            ]
        }
    },
    reducers: {
        setData: (state,value) => {state.data = value.payload},
        setAdmin: (state,value) => {state.admin = value.payload},
        setDataAdmin: (state,value) => {state.dataAdmin = value.payload},
        setResidueImg: (state,value) => {state.residueImg = value.payload},
        setPage: (state,value) => {state.page = value.payload},
    }
})

export const { setData, setAdmin, setDataAdmin, setResidueImg, setPage } = resource.actions

export const data = state => state.res.data
export const admin = state => state.res.admin
export const dataAdmin = state => state.res.dataAdmin
export const residueImg = state => state.res.residueImg
export const page = state => state.res.page

export const fetchImg = createAsyncThunk("asyncimg/fetchImg", async ({imgname,index,type}) => {
    try {
        const data = await getImage(imgname); // Your asynchronous logic
        return {"name":imgname,"index":index,"type":type,"data":await data};
    } catch (error) {
        throw error;
    }
})

const asyncResource = createSlice({
    name:"asyncimg",
    initialState: {
        data:[],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchImg.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchImg.fulfilled, (state, action) => {
            state.loading = false;
            if (state.data.length > 0) {
                if (state.data.filter((dt) => dt.name === action.payload.name).length <= 0) {
                    state.data = [...state.data,action.payload];
                }
            } else state.data = [action.payload];
        })
        .addCase(fetchImg.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
})

export const dataImg = state => state.asyncimg.data
export const dataLoading = state => state.asyncimg.loading
export const dataError = state => state.asyncimg.error

export default configureStore({
    reducer: {
        res: resource.reducer,
        asyncimg: asyncResource.reducer
    }
})